export const vinRegex = /\b[(A-H|J-N|P|R-Z|0-9)]{17}\b/g;
